module.exports = __webpack_public_path__ + "media/images/promo/bg_card_2-643906b0ef8e1fbe4f2dbc0f3cd796ce.jpg";